import {Box, Radio, Stack, Typography} from '@mui/material'
import React, {useEffect, useState} from 'react'
import Label from '../../customTable/Label'
import Switch from '../../../componet/Toastr/Switch'
import RestSaveButton from '../../customTable/RestSaveBtns'
import InputType from '../../customTable/InputType'
import ValidationFun from '../../../yup/ValidationFun'
import General from '../../../Api/SettingGeneral'
import MainBtn from '../../customTable/MainBtn'
import {OrderSchema, shappingSchema} from '../../../yup/SettingSchema'
import MySelect from '../../customTable/CustomSelectTest'
import NoNetWork from '../../customTable/NoNetWork'
import {useDispatch} from 'react-redux'
import {useSelector} from 'react-redux'
import {RootState} from '../../../store'
import {actions} from '../../../store/vender/Auth/auth.slice'
import { useTranslation } from 'react-i18next'

export default function Shapping({setOpen, setActive}: any) {
  const [isLoading, setIsLoading] = React.useState(false)
  const [errors, setErrors] = React.useState<any>({})
  const dispatch = useDispatch()
  const store = useSelector((state: RootState) => state.vender)
  const {sizeImages} = useSelector((state: any) => state.vender)

  const [data, setData] = React.useState<any>({
    is_refund_order: 1,
    unit: 'days',
    type: 1,
  })
  const submit = () => {
    ValidationFun(data, shappingSchema, setErrors, (value: any) => {
      General.editShapping(
        {
          ...data,
          shipping_type:
            data.type == 1
              ? 'free'
              : data.type == 2
              ? 'free_above_x_value'
              : data.type == 3
              ? 'fixed'
              : 'none',
          shipping_free: data.type == 1 ? 1 : 0,

          shipping_method: 'vendor',
          amount: data.type == 2 || data.type == 3 ? data.amount : 0,
          shipping_fixed_price: data.type == 2 ? data.shipping_fixed_price : null,
        },
        (res: any) => {
          if (
            store.sizeImages.is_general_enabled &&
            store.sizeImages.is_order_enabled &&
            store.sizeImages.is_payment_methods &&
            !store.sizeImages.is_shipping_enabled
          ) {
            dispatch(
              actions.setImagesSize({
                ...sizeImages,
                default_sku: res.default_sku,
                is_shipping_enabled: true,
              })
            )
            setOpen?.(true)
          }
          if (
            !store.sizeImages.is_general_enabled ||
            !store.sizeImages.is_order_enabled ||
            !store.sizeImages.is_payment_methods
          ) {
            dispatch(
              actions.setImagesSize({
                ...sizeImages,
                default_sku: res.default_sku,
                is_shipping_enabled: true,
              })
            )
            setOpen?.(true)
          }
          if (!store.sizeImages.is_general_enabled) {
            setActive(0)
          } else if (!store.sizeImages.is_order_enabled) {
            setActive(2)
          } else if (!store.sizeImages.is_payment_methods) {
            setActive(3)
          }
        },
        setIsLoading
      )
    })
  }
  useEffect(() => {
    General.getShapping((res: any) => {
      if (res.data) {
        setData({
          ...res.data,
          type:
            res.data.shipping_type == 'free'
              ? 1
              : res.data.shipping_type == 'free_above_x_value'
              ? 2
              : 3,
        })
      }
    }, setIsLoading)
  }, [])
const {t}=useTranslation()
  return (
    <NoNetWork>
      {' '}
      <>
        {!isLoading && (
          <Stack
            p='24px'
            borderRadius={'8px'}
            bgcolor={'var(--bs-app-header-base-bg-color)'}
            width={'100%'}
            // minHeight={'351px'}
            justifyContent={'space-between'}
          >
            <Stack pb='24px' borderBottom={data.type !== 0 ? '1px dashed #B5B5C3' : 'none'}>
              {/* <Stack mt='35px' gap={{xs: '16px'}} direction={'row'}>
          <Stack>
            <Label fs={{xs: '14px', sm: '16px'}} fw='600' text='Seller-ManagedShippingRules' />
          </Stack>
          <Switch
            name='status'
            value={data.is_cancel_order === 1 ? true : false}
            handleChange={() => {
              setData({...data, is_cancel_order: data.is_cancel_order === 1 ? 0 : 1})
            }}
          />
        </Stack> */}
              <Stack alignItems={'center'} mt='35px' gap={{xs: '23px'}} direction={'row'}>
                <Stack>
                  <Label
                    fs={{xs: '14px', sm: '16px'}}
                    fw='600'
                    text='Seller-ManagedShippingRules'
                  />
                </Stack>

                <Box maxWidth={'269px'} width='100%'>
                  <MySelect
                    errors={errors}
                    option={[
                      {name: t('FreeShipping'), id: 1},
                      {name: 'FreeshippingaboveXamount', id: 2},
                      {name: 'FixedPriceShipping', id: 3},
                    ]}
                    values={data}
                    setValues={setData}
                    name='type'
                    value={{id: data.type || 1}}
                  />{' '}
                </Box>
              </Stack>
              {data.type === 2 && (
                <Stack
                  borderBottom='1px dashed #B5B5C3'
                  p='32px 0'
                  alignItems={'center'}
                  mt='24px'
                  direction={'row'}
                  width={'100%'}
                  position={'relative'}
                  gap={'16px'}
                >
                  <Stack direction={'row'} gap='5px'>
                    <Label text='shippingPrice' />
                  </Stack>
                  <Box maxWidth={'300px'} width='100%'>
                    <InputType
                      isCurrency
                      errors={errors}
                      name={'shipping_fixed_price'}
                      change={setData}
                      value={data}
                      type='text'
                    />
                  </Box>
                </Stack>
              )}
              <Stack>
                {data.type !== 0 && data.type !== 1 && (
                  <Stack
                    alignItems={'center'}
                    mt='24px'
                    direction={'row'}
                    width={'100%'}
                    position={'relative'}
                    gap={'16px'}
                  >
                    <Stack direction={'row'} gap='5px'>
                      <Label text='invoiceAmount' />
                    </Stack>
                    <Box maxWidth={'300px'} width='100%'>
                      <InputType
                        isCurrency
                        errors={errors}
                        name={'amount'}
                        change={setData}
                        value={data}
                        type='text'
                      />
                    </Box>
                  </Stack>
                )}
              </Stack>
            </Stack>
            <Stack>
              {data.type !== 0 && (
                <Stack>
                  <Stack gap='14px' borderBottom={'1px dashed #B5B5C3'} p='32px 0'>
                    <Label fw='600' text='Timeframe' />
                    <Stack gap='10px' direction={'row'}>
                      <Stack alignItems={'center'} direction={'row'}>
                        <Radio
                          disabled={data.is_refund_order === 0 ? true : false}
                          sx={{
                            color: 'var(--main-color)',
                            '&.Mui-checked': {
                              color: 'var(--main-color)',
                            },
                            mt: '4px',
                          }}
                          checked={data.unit === 'hours' ? true : false}
                          onClick={() => {
                            setData({...data, unit: 'hours'})
                          }}
                        />
                        <Label text='hours' />
                      </Stack>{' '}
                      <Stack alignItems={'center'} direction={'row'}>
                        <Radio
                          disabled={data.is_refund_order === 0 ? true : false}
                          sx={{
                            color: 'var(--main-color)',
                            '&.Mui-checked': {
                              color: 'var(--main-color)',
                            },
                            mt: '4px',
                          }}
                          checked={data.unit === 'days' ? true : false}
                          onClick={() => {
                            setData({...data, unit: 'days'})
                          }}
                        />
                        <Label text='day' />
                      </Stack>{' '}
                    </Stack>{' '}
                    <Stack
                      alignItems={'center'}
                      mt='24px'
                      direction={'row'}
                      width={'100%'}
                      position={'relative'}
                      gap={'16px'}
                    >
                      <Stack direction={'row'} gap='5px'>
                        <Label text='from' />
                      </Stack>
                      <Box maxWidth={'164px'} width='100%'>
                        <InputType
                          errors={errors}
                          name={'from'}
                          change={setData}
                          value={data}
                          type='text'
                        />
                      </Box>
                      <Stack direction={'row'} gap='5px'>
                        <Label text='to' />
                      </Stack>
                      <Box maxWidth={'164px'} width='100%'>
                        <InputType
                          errors={errors}
                          name={'to'}
                          change={setData}
                          value={data}
                          type='text'
                        />
                      </Box>
                    </Stack>
                  </Stack>
                  <Stack gap='24px' p='32px 0 0 0'>
                    <Label fw='600' text='ShippingPolicySetup(Optional)' />
                    <Stack width={'100%'} position={'relative'} gap={'12px'}>
                      <Stack direction={'row'} gap='5px'>
                        <Label fw='600' text='HyperlinkTitle' />
                      </Stack>
                      <Box maxWidth={'350px'} width='100%'>
                        <InputType
                          errors={errors}
                          name={'shipping_policy_page_title'}
                          change={setData}
                          value={data}
                          type='text'
                        />
                      </Box>
                    </Stack>
                    <Stack width={'100%'} position={'relative'} gap={'12px'}>
                      <Stack direction={'row'} gap='5px'>
                        <Label fw='600' text='HyperlinkURL' />
                      </Stack>
                      <Box maxWidth={'350px'} width='100%'>
                        <InputType
                          errors={errors}
                          name={'shipping_policy_page_url'}
                          change={setData}
                          value={data}
                          type='text'
                        />
                      </Box>
                    </Stack>
                  </Stack>
                </Stack>
              )}{' '}
              <Stack mt='15px' alignItems={'flex-end'}>
                {store.permissions &&
                  store.permissions &&
                  store.permissions.includes('shipping_update') && (
                    <MainBtn isLoading={isLoading} width='auto' text='save' handelSubmit={submit} />
                  )}
              </Stack>{' '}
            </Stack>
          </Stack>
        )}
      </>
    </NoNetWork>
  )
}
